module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/setting/banks/banks-show/banks-show.component.scss
// module id = ./src/app/views/setting/banks/banks-show/banks-show.component.scss
// module chunks = main